import clsx from 'clsx'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import * as Yup from 'yup'
import httpService from '../../../../setup/http/httpServices'
import { requestPassword } from '../redux/AuthCRUD'
import { message } from 'antd'
import { set } from 'lodash'

interface RouteParams {
  token: string;
}

export function SetPassword() {
  const {token} = useParams<RouteParams>()
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [newPassword, setNewPassword] = useState('')
  const [newPasswordErrorMsg, setNewPasswordErrorMsg] = useState('')
  const [newPasswordError, setNewPasswordError] = useState(false)
  const [confirmPassword, setConfirmPassword] = useState('')
  const [confirmPasswordErrorMsg, setConfirmPasswordErrorMsg] = useState('')
  const [confirmPasswordError, setConfirmPasswordError] = useState(false)

  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (!newPassword) {
      setNewPasswordError(true)
      setNewPasswordErrorMsg('Password is required')
      return;
    }
    if (newPassword.length < 3) {
      setNewPasswordError(true)
      setNewPasswordErrorMsg('Minimum 3 symbols')
      return;
    }
    if (newPassword.length > 50) {
      setNewPasswordError(true)
      setNewPasswordErrorMsg('Maximum 50 symbols')
      return;
    }
    if (newPassword !== confirmPassword) {
      setConfirmPasswordError(true)
      setConfirmPasswordErrorMsg('Password does not match')
      return;
    }
    setNewPasswordError(false)
    setNewPasswordErrorMsg('')
    setConfirmPasswordError(false)
    setConfirmPasswordErrorMsg('')


    console.log({
      newPassword,
      confirmPassword,
      token
    });

    httpService.postData(
      '/auth/password/reset/'+token,
      {
        newPassword,
        confirmPassword,
      },
      (res)=>{
        console.log(res);
        message.success('Password reset successful.Please login.')
        setHasErrors(false)
      },
      (err)=>{
        console.log(err);
        message.error('Password reset failed.')
        setHasErrors(true)
        
      }
    )
  }
  return (
    <>
      <form
        className='form w-75 position-relative flex fv-plugins-bootstrap5 fv-plugins-framework '
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={handleSubmit}
      >
        <div className='w-100'>
          <div>
            {/* begin::Title */}
            <h1 style={{ fontWeight: 700, fontSize: '36px', lineHeight: '54px' }}>
              Create New Password
            </h1>
            {/* end::Title */}

            {/* begin::Link */}
            <div className='fs-14'>Your new password must be different from previous password.</div>
            {/* end::Link */}
          </div>

          {/* begin::Title */}
          {hasErrors === true && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>
                Sorry, looks like there are some errors detected, please try again.
              </div>
            </div>
          )}

          {hasErrors === false && (
            <div className='mb-10 bg-light-info p-8 rounded'>
              <div className='text-info'>
                Password reset successful.Please <Link to='/auth/admin/login'>Login</Link>.
              </div>
            </div>
          )}
          {/* end::Title */}

          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <div className='d-flex justify-content-between mt-n5'>
              <div className='d-flex flex-stack mb-2'>
                {/* begin::Label */}
                <label className='form-label fs-14 mb-0 mt-5 required'>Password</label>

                {/* end::Label */}
                {/* begin::Link */}
                {/* <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{marginLeft: '5px'}}
            >
              Forgot Password ?
            </Link> */}
                {/* end::Link */}
              </div>
            </div>
            <input
              type='password'
              placeholder='Enter your password'
              autoComplete='off'
              // {...formik.getFieldProps('newPassword')}
              value={newPassword}
              onChange={(e) => {
                console.log(e.target.value);
                setNewPassword(e.target.value)
                setNewPasswordError(false)
                setNewPasswordErrorMsg('')
              }
              }
              className={clsx(
                'form-control form-control-lg form-control-solid rounded-4'
              )}
            />
            {newPasswordError && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert text-danger'>{newPasswordErrorMsg}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <div className='d-flex justify-content-between mt-n5'>
              <div className='d-flex flex-stack mb-2'>
                {/* begin::Label */}
                <label className='form-label fs-14 mb-0 mt-5 required'>Confirm Password</label>

                {/* end::Label */}
                {/* begin::Link */}
                {/* <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{marginLeft: '5px'}}
            >
              Forgot Password ?
            </Link> */}
                {/* end::Link */}
              </div>
            </div>
            <input
              type='password'
              placeholder='Re-enter your password'
              autoComplete='off'
              // value={formik.values.confirmPassword}
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value)
                setConfirmPasswordError(false)
                setConfirmPasswordErrorMsg('')
              }
              }
              className={clsx(
                'form-control form-control-lg form-control-solid rounded-4'
              )}
            />
            {confirmPasswordError && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert text-danger'>{confirmPasswordErrorMsg}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <button
              type='submit'
              id='kt_password_reset_submit'
              className='btn btn-primary w-100 mb-5'
            >
              <span className='indicator-label'>Reset Password</span>
              {loading && (
                <span className='indicator-progress'>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
